import { render, staticRenderFns } from "./RulesAndFormulas.vue?vue&type=template&id=6e5c6d33&scoped=true"
import script from "./RulesAndFormulas.vue?vue&type=script&lang=js"
export * from "./RulesAndFormulas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5c6d33",
  null
  
)

export default component.exports